export default __webpack_public_path__ + "static/media/deep.f91d9e05.webp";